import { api } from "./client";
import { Post, PostType, ExternalUrlKind } from "../types/gordost";

export interface PostFileIn {
  s3_key: string;
  original_filename: string;
  mime_type: string;
  size_bytes: number;
  sort_order: number;
}

export interface PostCreateIn {
  student_id: number;
  post_type: PostType;
  title: string;
  body: string;
  event_date: string | null;
  external_url?: string;
  external_url_kind?: ExternalUrlKind;
  files: PostFileIn[];
}

export interface PostUpdateIn {
  title?: string;
  body?: string;
  event_date?: string | null;
  external_url?: string | null;
  external_url_kind?: ExternalUrlKind | null;
  /** Передавать ТОЛЬКО при замене файлов: бэкенд заменит весь набор файлов
   *  поста на этот. Если не передавать — файлы остаются как есть. */
  files?: PostFileIn[];
}

export interface UploadUrlResponse {
  upload_url: string;
  fields: Record<string, string>;
  s3_key: string;
  expires_at: string;
}

export interface ListPostsParams {
  student_id?: number;
  year_id?: number;
  include_archived?: boolean;
}

export interface ListPostsResponse {
  items: Post[];
  total: number;
}

export async function listPosts(params: ListPostsParams): Promise<ListPostsResponse> {
  const { data } = await api.get("/posts", { params });
  return data;
}

export async function getPost(post_id: number): Promise<Post> {
  const { data } = await api.get(`/posts/${post_id}`);
  return data;
}

export async function createPost(payload: PostCreateIn): Promise<Post> {
  const { data } = await api.post("/posts", payload);
  return data;
}

export async function updatePost(
  post_id: number,
  payload: PostUpdateIn
): Promise<Post> {
  const { data } = await api.patch(`/posts/${post_id}`, payload);
  return data;
}

export async function deletePost(post_id: number): Promise<{ ok: boolean }> {
  const { data } = await api.delete(`/posts/${post_id}`);
  return data;
}

export async function requestUploadUrl(
  filename: string,
  mime_type: string,
  size_bytes: number
): Promise<UploadUrlResponse> {
  const { data } = await api.post("/posts/upload-url", {
    filename,
    mime_type,
    size_bytes,
  });
  return data;
}
